"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { toast } from "sonner";
import Link from "next/link";
import { ArrowLeft, ArrowRight, Dumbbell, Mail, MailCheck } from "lucide-react";
import FormInput from "@/shared/components/ui/form-input";
import { Button } from "@/shared/components/ui/button";
import { Spinner } from "@/shared/components/ui/spinner";
import { authClient } from "@/shared/config/authClient.config";
import { forgotPasswordSchema } from "../validations/client-validation";
const ForgotPasswordForm = () => {
  const $ = _c(14);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = zodResolver(forgotPasswordSchema);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      resolver: t0,
      mode: "onSubmit",
      defaultValues: {
        email: ""
      }
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    control,
    handleSubmit,
    formState
  } = useForm(t1);
  const isLoading = formState.isSubmitting;
  const [sent, setSent] = useState(false);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = async data => {
      const {
        error
      } = await authClient.requestPasswordReset({
        email: data.email,
        redirectTo: "/reset-password"
      });
      if (error) {
        toast.error(error.message || "Could not send the reset email");
        return;
      }
      setSent(true);
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== handleSubmit) {
    t3 = handleSubmit(t2);
    $[3] = handleSubmit;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const onSubmit = t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="text-center"><Link href="/" className="inline-flex items-center justify-center w-20 h-20 bg-primary rounded-full mb-6"><Dumbbell className="w-10 h-10 -rotate-45 text-accent" /></Link><h2 className="text-3xl tracking-tight mb-2">Reset password</h2><p className="text-muted-foreground text-sm">Enter your email and we'll send you a reset link.</p></div>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== control || $[7] !== isLoading || $[8] !== onSubmit || $[9] !== sent) {
    t5 = sent ? <div className="flex flex-col items-center text-center space-y-4 mt-4"><div className="flex h-16 w-16 items-center justify-center rounded-full bg-primary/10 text-primary"><MailCheck className="h-8 w-8" /></div><p className="text-sm text-muted-foreground max-w-sm">If an account exists for that email, a password reset link is on its way. The link expires in 5 minutes.</p></div> : <form onSubmit={onSubmit} className="space-y-6"><FormInput label="Email" name="email" type="text" placeholder="example@email.com" icon={<Mail size={18} />} control={control} disabled={isLoading} /><Button type="submit" className="group w-full flex items-center justify-center gap-2" disabled={isLoading}><span className="text-accent">Send reset link</span>{isLoading ? <Spinner className="text-accent" /> : <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform text-accent" />}</Button></form>;
    $[6] = control;
    $[7] = isLoading;
    $[8] = onSubmit;
    $[9] = sent;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="text-center mt-6"><Link href="/login" className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-primary hover:underline transition-colors"><ArrowLeft size={16} />Back to login</Link></div>;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5) {
    t7 = <div className="w-full max-w-110 flex flex-col space-y-2 py-8 px-2 md:px-0">{t4}{t5}{t6}</div>;
    $[12] = t5;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};
export default ForgotPasswordForm;